import { render, staticRenderFns } from "./entity-comments.vue?vue&type=template&id=45d37044"
import script from "./entity-comments.vue?vue&type=script&lang=js"
export * from "./entity-comments.vue?vue&type=script&lang=js"
import style0 from "./entity-comments.vue?vue&type=style&index=0&id=45d37044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports